import {Link} from 'react-router';
import React from 'react';
import {Attempts} from '@types';

export const UserAttemptsContent = ({
    problemId,
    userAttempts,
}: {
    problemId: number | string;
    userAttempts: Attempts;
}) => {
    return userAttempts.tries > 0 ? (
        <Link to={`/problems/${problemId}/paths-history`} className="link">
            {userAttempts.solved} / {userAttempts.tries}
        </Link>
    ) : (
        'N/A'
    );
};
